import type { PageView, Interaction, InteractionOptions, PageViewOptions } from './'

const pageview = 'pageview'
const interaction = 'interaction'
const viewerRole = 'viewer'
const dataLayer = 'dataLayer'

class GtmUtils {
  static registerPageView({
    section,
    subsection,
    pathname,
    isAuthenticated,
    role,
    language
  }: PageViewOptions) {
    window[dataLayer] = window[dataLayer] ? window[dataLayer] : []
    window[dataLayer].push(
      this.createPageView({ section, subsection, pathname, isAuthenticated, role, language })
    )
  }

  static registerInteraction({
    category,
    action,
    label = '',
    language,
    section,
    logged = ''
  }: InteractionOptions) {
    window[dataLayer] = window[dataLayer] ? window[dataLayer] : []
    window[dataLayer].push(
      this.createInteraction({ category, action, label, language, section, logged })
    )
  }

  /**
   * Gets the Google Analytics _ga cookie value
   * @returns {string | null} _ga cookie value (ex: GA1.1.1141249729.1751931652) or null if not found
   */
  static getGoogleAnalyticsCookie(): string | null {
    if (typeof document === 'undefined') return null
    try {
      const match = document.cookie.match(/(?:^|;\s*)_ga=(GA1\.\d+\.\d+\.\d+)(?=;|$)/)

      return match ? match[1] : null
    } catch (error) {
      console.warn('Error getting Google Analytics _ga cookie:', error)

      return null
    }
  }

  private static createPageView({
    isAuthenticated,
    section,
    subsection,
    role = viewerRole,
    language = '',
    pathname = ''
  }: PageViewOptions) {
    const pageView: PageView = {
      event: pageview,
      section: section,
      subsection: subsection,
      language: language.toLowerCase(),
      logged: isAuthenticated,
      userRole: role.toLowerCase(),
      pathname: pathname
    }

    return pageView
  }

  private static createInteraction({
    category,
    action,
    label,
    language,
    section = '',
    logged = ''
  }: InteractionOptions) {
    const interactionEvent: Interaction = {
      event: interaction,
      event_category: category,
      event_action: action,
      event_label: label ?? '',
      language: language?.toLowerCase() ?? '',
      section: section ?? '',
      logged: logged ?? ''
    }

    return interactionEvent
  }
}

export default GtmUtils
